if (!customElements.get('td-variant-image-filter')) {
  class TDVariantImageFilter extends HTMLElement {
    static SELECTORS = {
      config: '[data-td-variant-media]',
      viewer: '[id^="GalleryViewer"]',
      thumbnails: '[id^="GalleryThumbnails"]',
      slide: 'li[data-media-id]',
      thumbItem: 'li[data-target]',
      activeSlide: 'li[data-media-id].is-active',
    };

    connectedCallback() {
      const configEl = this.querySelector(TDVariantImageFilter.SELECTORS.config);
      if (!configEl) return;

      try {
        const config = JSON.parse(configEl.textContent);
        this.variantMediaMap = config.variantMediaMap || {};
        this.currentVariantId = config.currentVariantId;
      } catch (error) {
        console.warn('TDVariantImageFilter: invalid configuration JSON.', error);
        return;
      }

      if (Object.keys(this.variantMediaMap).length === 0) return;

      this.sectionId = this.dataset.tdSectionId;
      this.gallery = document.getElementById(`MediaGallery-${this.sectionId}`);
      if (!this.gallery) return;

      this.allMappedMediaIds = new Set();
      this.variantMediaSets = {};

      Object.entries(this.variantMediaMap).forEach(([variantId, mediaIds]) => {
        const idSet = new Set(mediaIds.map(String));
        this.variantMediaSets[variantId] = idSet;
        idSet.forEach((id) => this.allMappedMediaIds.add(id));
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantSubscription = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      } else {
        console.warn('TDVariantImageFilter: theme variant change pub/sub API is unavailable.');
      }

      this.filterGallery();
    }

    disconnectedCallback() {
      if (this.variantSubscription) this.variantSubscription();
    }

    onVariantChange({ data }) {
      if (data.sectionId !== this.sectionId || !data.variant) return;
      this.currentVariantId = data.variant.id;
      requestAnimationFrame(() => this.filterGallery());
    }

    shouldShow(mediaId) {
      const id = String(mediaId);

      // Media not mapped to any variant stays visible (shared/generic media)
      if (!this.allMappedMediaIds.has(id)) return true;

      const variantSet = this.variantMediaSets[String(this.currentVariantId)];
      if (!variantSet) return true;

      return variantSet.has(id);
    }

    filterGallery() {
      const viewer = this.gallery.querySelector(TDVariantImageFilter.SELECTORS.viewer);
      const thumbnails = this.gallery.querySelector(TDVariantImageFilter.SELECTORS.thumbnails);

      if (!viewer) return;

      const slides = Array.from(viewer.querySelectorAll(TDVariantImageFilter.SELECTORS.slide));
      const thumbItems = thumbnails
        ? Array.from(thumbnails.querySelectorAll(TDVariantImageFilter.SELECTORS.thumbItem))
        : [];
      const visibility = new Map();

      slides.forEach((slide) => {
        visibility.set(slide, this.shouldShow(slide.dataset.mediaId));
      });

      const visibleCount = Array.from(visibility.values()).filter(Boolean).length;
      const showAll = visibleCount === 0;

      slides.forEach((slide) => {
        const visible = showAll || visibility.get(slide);
        slide.style.display = visible ? '' : 'none';
      });

      thumbItems.forEach((thumb) => {
        const matchingSlide = slides.find((s) => s.dataset.mediaId === thumb.dataset.target);
        const visible = !matchingSlide || showAll || visibility.get(matchingSlide);
        thumb.style.display = visible ? '' : 'none';
      });

      const activeSlide = viewer.querySelector(TDVariantImageFilter.SELECTORS.activeSlide);
      if (activeSlide && activeSlide.style.display === 'none') {
        const firstVisible = slides.find((s) => s.style.display !== 'none');
        if (firstVisible) {
          this.gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
        }
      }

      if (viewer.resetPages) viewer.resetPages();
      if (thumbnails?.resetPages) thumbnails.resetPages();
    }
  }

  customElements.define('td-variant-image-filter', TDVariantImageFilter);
}
